<template>
  <div class="wrapper-box">
    <web-header></web-header>
    <web-content></web-content>
    <web-parallax></web-parallax>
    <web-footer></web-footer>
    <web-arrow-up></web-arrow-up>
  </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import arrowUp from "@/components/arrowUp.vue";
export default {
  name: "home",
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webArrowUp: arrowUp
  }
};
</script>
<style lang="scss">
.wrapper-box {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/products.vue